import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageDetail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 16,
			width: 14,
			height: 2,
			rx: .94,
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 20,
			width: 14,
			height: 2,
			rx: .94,
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 2H8C6.89543 2 6 2.89543 6 4V12C6 13.1046 6.89543 14 8 14H16C17.1046 14 18 13.1046 18 12V4C18 2.89543 17.1046 2 16 2ZM8.00004 3.33334H16C16.3682 3.33334 16.6667 3.63182 16.6667 4.00001V9.57334L14.5334 7.75334C13.8517 7.19245 12.8684 7.19245 12.1867 7.75334L7.33337 11.8V4.00001C7.33337 3.63182 7.63185 3.33334 8.00004 3.33334ZM8.37329 12.6667H16C16.3681 12.6667 16.6666 12.3682 16.6666 12V11.3333L13.66 8.77334C13.4759 8.63667 13.224 8.63667 13.04 8.77334L8.37329 12.6667Z",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.33337,
			cy: 5.6665,
			r: 1,
			fill: "var(--main-color)"
		})
	]
});
export { SvgImageDetail as ReactComponent };
